<template>
  <page-edicion>
    <b-form class="formularioContrato container" @submit.prevent="guardar">
      <div class="content-card">
        <h1>Editar contrato de la Oferta</h1>
        <b-tabs content-class="mt-3" small-card>
          <b-tab title="Contrato" active>
            <b-form-group label="Formato del contrato a generar">
              <wysiwyg v-model="ofertaContrato.textoContrato" placeholder="Escriba aquí" :options="opcionesEditor" />
            </b-form-group>
          </b-tab>
          <b-tab title="Borrador">
            <b-form-group label="Formato del contrato en borrador">
              <wysiwyg v-model="ofertaContrato.textoBorrador" placeholder="Escriba aquí" :options="opcionesEditor" />
            </b-form-group>
          </b-tab>
        </b-tabs>
        <botonera-edicion url-cancelar="/ofertas" />
      </div>
    </b-form>
  </page-edicion>
</template>

<script>
import * as ofertasApi from "@/services/ofertas";
import EditorShortcodes from "@/components/editor/ModuloShortcodesContrato.vue";

export default {
  data() {
    return {
      ofertaContrato: ofertasApi.crearOfertaContrato(),
      opcionesEditor: {
        customModules: [EditorShortcodes],
        forcePlainTextOnPaste: true,
      },
    };
  },
  async mounted() {
    this.ofertaContrato = await ofertasApi.cargarContratoVersion(this.$route.params.id);
  },
  methods: {
    async guardar() {
      await ofertasApi.guardarContratoVersion(this.ofertaContrato);
      this.$router.push("/ofertas");
    },
  },
};
</script>
